module.exports = __webpack_public_path__ + "img/the-rise-framework-cover-book.67938d07.jpg";